"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pressable = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./Pressable.css");
var _useEventHandler = require("@cbhq/cds-common/system/useEventHandler");
var _linaria = require("../utils/linaria");
var _ButtonOrLink = require("./ButtonOrLink");
var _Interactable = require("./Interactable");
var _interactableCSSProperties = require("./interactableCSSProperties");
const _excluded = ["as", "children", "className", "loading", "onPress", "onKeyPress", "noScaleOnPress", "tabIndex", "eventConfig"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const scaledDownState = "cds-scaledDownState-sxr2bd6";
const pressableResetStyles = "cds-pressableResetStyles-p1yut83c";
const pressablePaddingResetStyles = "cds-pressablePaddingResetStyles-p1vadhgi";
const loadingStyles = "cds-loadingStyles-lfojgii";
const Pressable = /*#__PURE__*/(0, _react.forwardRef)(function Pressable(_ref, ref) {
  let as = _ref.as,
    children = _ref.children,
    className = _ref.className,
    loading = _ref.loading,
    onPress = _ref.onPress,
    onKeyPress = _ref.onKeyPress,
    noScaleOnPress = _ref.noScaleOnPress,
    tabIndex = _ref.tabIndex,
    eventConfig = _ref.eventConfig,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  let resetStyles = ''; // empty string is falsy
  const borderColor = props.borderColor;
  if (!className) {
    if (!borderColor) {
      resetStyles = pressableResetStyles;
    } else {
      resetStyles = pressablePaddingResetStyles;
    }
  }
  const onEventHandler = (0, _useEventHandler.useEventHandler)('Button', 'onPress', eventConfig);
  const onClick = (0, _react.useCallback)(event => {
    onPress === null || onPress === void 0 ? void 0 : onPress(event);
    onEventHandler();
  }, [onPress, onEventHandler]);
  return /*#__PURE__*/_react.default.createElement(_Interactable.Interactable, _extends({
    "aria-busy": loading,
    as: as !== null && as !== void 0 ? as : _ButtonOrLink.ButtonOrLink,
    onClick: onClick,
    onKeyPress: onKeyPress
  }, props, {
    ref: ref,
    "aria-disabled": undefined // Reakit adds this prop, but it's bad practice - https://jira.coinbase-corp.com/browse/CDS-2392
    ,
    className: (0, _linaria.cx)(!noScaleOnPress && scaledDownState, className, resetStyles, loading && loadingStyles),
    loading: loading,
    tabIndex: tabIndex
  }), children);
});
exports.Pressable = Pressable;